import React, { useEffect, useState } from "react";
import Switch from "../../../../../../../components/Inputs/Switch/Switch";
import styles from '../styles.module.scss';
import { FormControlLabel, Radio, RadioGroup, withStyles } from "@material-ui/core";
import Button from "../../../../../../../components/Buttons/Button";
import Dropdown from "../../../../../../../components/Inputs/Dropdown";
import TextInput from "../../../../../../../components/Inputs/TextInput";
import { AZURE_ZKTECO_CONTROLLER_CONFIGS, ISTAR_CONTROLLER_CONFIGS, OTHERS_CONTROLLER_CONFIGS, SPINTLY_CONTROLLER_CONFIGS, WITHOUT_CONTROLLER_CONFIGS } from "../../../../../../../constants/list/AccessPointTypeList";
import { useDispatch } from "react-redux";
import { doGetSpintlySerialNumber } from "../../../../../../../redux/thunks/controllers";
import FlexColumn from "../../../../../../../components/FlexBox/FlexColumn";
import Typography from "../../../../../../../components/Typography/Typography";
import { colors } from "../../../../../../../styles/colors";
import SButton from "../../../../../../../components/SButton/SButton";
import { ArrowRightIcon } from "@phosphor-icons/react";
import BoardMapping from "../BoardMapping";
import FlexRow from "../../../../../../../components/FlexBox/FlexRow";

const INCORRECT_ERROR = "Serial number doesn't support the configuration";

const StyledRadio = withStyles({
    root: {
        color: '#BDC7D9',
        '&$checked': {
            color: '#03BFFF',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const Configuration = ({ hNext, hBack, accessPointDetails, inProgress = false }) => {

    const dispatch = useDispatch();

    const [accessPointName, setAccessPointName] = useState('');
    const [configuration, setConfiguration] = useState({
        name: '',
        value: '',
        formOptions: {
            entry: false,
            exit: false,
            control: false,
            lockingMechanism: false,
            relayTime: false,
            attendanceAvailable: false,
            doorSensor: false,
        },
        skipSerialValidations: false,
        validSerials: {
            entry: [],
            exit: [],
            control: [],
        },
        lockingMech: {},
        channelExtenderSettings: {
            channelDetails: [],
            channelMapping: {},
            application: "Elevator",
            numberOfBoards: 4,
            channelOptions: []
        }
    });

    const [auxInput, setAuxInput] = useState({
        enabled: false,
        inputType: '2'
    })
    const [entryDeviceSerialNum, setEntryDeviceSerialNum] = useState({
        value: '',
        description: '',
        error: '',
    });
    const [exitDeviceSerialNum, setExitDeviceSerialNum] = useState({
        value: '',
        description: '',
        error: '',
    });
    const [controllerDeviceSerialNum, setControllerDeviceSerialNum] = useState({
        value: '',
        description: '',
        error: '',
        vendorSerialNumber: '',
        vendorToSpintlySerialNum: ''
    });

    const [disabled, setDisabled] = useState(true);

    const [showElevatorMapping, setElevatorMapping] = useState(false);

    useEffect(() => {
        if (accessPointDetails?.accessPointName) {
            setAccessPointName(accessPointDetails?.accessPointName)
        }
        if (accessPointDetails?.configuration) {
            setConfiguration(accessPointDetails?.configuration)
        }
        if (accessPointDetails?.auxInput) {
            setAuxInput(accessPointDetails?.auxInput)
        }
        if (accessPointDetails?.entryDeviceSerialNum) {
            setEntryDeviceSerialNum(accessPointDetails?.entryDeviceSerialNum)
        }
        if (accessPointDetails?.exitDeviceSerialNum) {
            setExitDeviceSerialNum(accessPointDetails?.exitDeviceSerialNum)
        }
        if (accessPointDetails?.controllerDeviceSerialNum) {
            setControllerDeviceSerialNum(accessPointDetails?.controllerDeviceSerialNum)
        }
    }, [accessPointDetails])

    useEffect(() => {
        let disabledValue = false;
        const isAzure_zkteco = accessPointDetails?.withController ? ['2', '3', '5']?.includes(accessPointDetails?.controllerType) : false;
        if (!isAzure_zkteco && configuration.formOptions.entry) {
            if (entryDeviceSerialNum.value === '' || entryDeviceSerialNum.error !== '') {
                disabledValue = true;
            }
        }

        if (!isAzure_zkteco && configuration.formOptions.exit) {
            if (exitDeviceSerialNum.value === '' || exitDeviceSerialNum.error !== '') {
                disabledValue = true;
            }
            if (
                entryDeviceSerialNum?.value?.substring(0, 4) !== exitDeviceSerialNum?.value?.substring(0, 4)
            ) {
                disabledValue = true;
            }
            if (entryDeviceSerialNum?.value === exitDeviceSerialNum?.value) {
                disabledValue = true;
            }
        }

        if (configuration.formOptions.control || (accessPointDetails?.withController && accessPointDetails?.controllerType !== '4')) {
            if (controllerDeviceSerialNum.value === '' || controllerDeviceSerialNum.error !== '') {
                disabledValue = true;
            }
        }

        if ((!isAzure_zkteco) && accessPointName?.trim()?.length <= 0) {
            disabledValue = true;
        }

        if (!configuration?.value) {
            disabledValue = true
        }

        if (configuration?.value === 9 && (!configuration?.channelExtenderSettings?.application || !configuration?.channelExtenderSettings?.numberOfBoards)) {
            disabledValue = true
        }

        setDisabled(disabledValue);
    }, [
        configuration?.value,
        configuration.formOptions.entry,
        configuration.formOptions.exit,
        configuration.formOptions?.control,
        entryDeviceSerialNum?.value,
        exitDeviceSerialNum?.value,
        controllerDeviceSerialNum,
        entryDeviceSerialNum.error,
        exitDeviceSerialNum.error,
        accessPointName,
        accessPointDetails?.controllerType,
        accessPointDetails?.withController,
        configuration?.channelExtenderSettings?.application,
        configuration?.channelExtenderSettings?.numberOfBoards
    ]);

    function checkError(value, field) {
        if (field === 'entry') {
            if (!configuration?.validSerials?.entry?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
        if (field === 'exit') {
            if (!configuration?.validSerials?.exit?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
        if (field === 'controller') {
            if (!configuration?.validSerials?.control?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
    }

    const handleSerialDescription = (value, field) => {
        const switchCase = value.substring(0, 4);
        let description = '';
        switch (String(switchCase)) {
            case '1001':
            case '1002':
            case '1016':
            case '101F':
            case '1021':
            case '1026':
            case '1032':
            case '1028':
            case '1029':
            case '1033':
            case '1034':
            case '103B':
            case '103A':
            case '103F':
            case '1042':
                description = 'Mobile/Card';
                break;
            case '1023':
            case '1015':
                description = 'Mobile/Card/Fingerprint';
                break;
            case '1024':
            case '1025':
            case '103D':
            case '102F':
                description = 'Face/Card';
                break;
            case '102D':
                description = 'Face';
                break;
            case '1027':
                description = 'Mobile';
                break;
            case '1038':
                description = 'Mobile/QR/Card';
                break;
            default:
                break;
        }

        let error = '';

        error = !configuration?.skipSerialValidations ? checkError(value, field) : '';

        if (field === 'entry') {
            setEntryDeviceSerialNum({ description: description, value: value?.trim(), error: error });
        }
        if (field === 'exit') {
            setExitDeviceSerialNum({ description: description, value: value?.trim(), error: error });
        }
        if (field === 'controller') {
            setControllerDeviceSerialNum({ description: description, value: value?.trim(), error: error });
        }
    };

    const handleNext = () => {
        //IF controller is azure
        if (['2', '5']?.includes(accessPointDetails?.controllerType) &&
            (controllerDeviceSerialNum?.value !== controllerDeviceSerialNum?.vendorSerialNumber)
        ) {
            dispatch(doGetSpintlySerialNumber(controllerDeviceSerialNum?.value, (data) => {
                setControllerDeviceSerialNum(prev => ({
                    ...prev,
                    vendorSerialNumber: controllerDeviceSerialNum?.value,
                    vendorToSpintlySerialNum: data?.message?.serialNumber
                }));
                setEntryDeviceSerialNum(prev => ({ ...prev, value: data?.message?.serialNumber }))

                const toSend = {
                    accessPointName,
                    configuration,
                    auxInput,
                    entryDeviceSerialNum: { ...entryDeviceSerialNum, value: data?.message?.serialNumber },
                    exitDeviceSerialNum,
                    controllerDeviceSerialNum: {
                        ...controllerDeviceSerialNum,
                        vendorSerialNumber: controllerDeviceSerialNum?.value,
                        vendorToSpintlySerialNum: data?.message?.serialNumber
                    }
                }
                hNext && hNext(toSend, 3);

            }))
        } else if (configuration?.value === 9 && Object?.keys(configuration?.channelExtenderSettings?.channelMapping || {})?.length <= 0) {
            setElevatorMapping(true)
        } else {
            const toSend = {
                accessPointName,
                configuration,
                auxInput,
                entryDeviceSerialNum,
                exitDeviceSerialNum,
                controllerDeviceSerialNum
            }
            hNext && hNext(toSend, 3);
        }

        // const toSend = {
        //     accessPointName,
        //     configuration,
        //     auxInput,
        //     entryDeviceSerialNum,
        //     exitDeviceSerialNum,
        //     controllerDeviceSerialNum
        // }
        // hNext && hNext(toSend, 3);
    }

    return (<>
        <div className={styles['column-container']} style={{ gap: '1rem', width: '100%', marginBottom: '4rem' }}>
            <Dropdown
                placeholder="Configuration"
                value={configuration?.name}
                onChange={(data) => {
                    const toSet = {
                        name: data.name,
                        value: data.value,
                        formOptions: {
                            entry: data.formOptions.entry,
                            exit: data.formOptions.exit,
                            control: data.formOptions.control,
                            lockingMechanism: data.formOptions.lockingMechanism,
                            relayTime: data.formOptions.relayTime,
                            attendanceAvailable: data.formOptions?.attendanceAvailable,
                            doorSensor: data.formOptions?.doorSensor,
                        },
                        skipSerialValidations: !!data?.skipSerialValidations,
                        validSerials: {
                            entry: data.validSerials.entry,
                            exit: data.validSerials.exit,
                            control: data.validSerials.control,
                        },
                        lockingMech: data?.lockingMech,
                    }

                    if (data?.value === 9) {
                        toSet["channelExtenderSettings"] = {
                            channelDetails: [],
                            channelMapping: {},
                            application: "Elevator",
                            numberOfBoards: 4,
                            channelOptions: [],
                        }
                    }
                    setConfiguration(toSet);
                    if (accessPointDetails?.configuration?.value !== data?.value) {
                        setAccessPointName('');
                        setAuxInput({
                            enabled: false,
                            inputType: '2'
                        });
                        setEntryDeviceSerialNum({
                            value: '',
                            description: '',
                            error: '',
                        });
                        setExitDeviceSerialNum({
                            value: '',
                            description: '',
                            error: '',
                        });
                        setControllerDeviceSerialNum({
                            value: '',
                            description: '',
                            error: '',
                        })
                    }

                }}
                data={
                    !accessPointDetails?.withController ? WITHOUT_CONTROLLER_CONFIGS :
                        accessPointDetails?.controllerType === '1' ? SPINTLY_CONTROLLER_CONFIGS :
                            accessPointDetails?.controllerType === '4' ? OTHERS_CONTROLLER_CONFIGS :
                                accessPointDetails?.controllerType === '2' ? AZURE_ZKTECO_CONTROLLER_CONFIGS :
                                    ISTAR_CONTROLLER_CONFIGS
                }
            />

            {(accessPointDetails?.withController && accessPointDetails?.controllerType !== '4') && (
                <>
                    <TextInput
                        name=""
                        maxLength={14}
                        description={controllerDeviceSerialNum?.description}
                        placeholder={['2', '5']?.includes(accessPointDetails?.controllerType) ? `${accessPointDetails?.controllerType === "2" ? "Azure" : "iStar"} Controller Serial Number` : "Controller Device Serial Number"}
                        value={controllerDeviceSerialNum?.value}
                        error={controllerDeviceSerialNum?.error}
                        onChange={(e) => handleSerialDescription(e.target.value, 'controller')}
                    />
                    {['2']?.includes(accessPointDetails?.controllerType) && <p style={{ marginLeft: '0.7rem', fontSize: '0.75rem', color: '#0A5DA6' }}>Enter the serial number present on the Azure controller</p>}
                </>
            )}

            {(!accessPointDetails?.withController || ['1', '4'].includes(accessPointDetails?.controllerType)) && <>
                <div className={styles['divider']} />

                <TextInput
                    name=""
                    placeholder="Access Point Name"
                    value={accessPointName}
                    onChange={(e) => {
                        const value = e.target.value;
                        setAccessPointName(value?.trimStart());
                    }}
                />
            </>}

            {(!accessPointDetails?.withController || ['1', '4'].includes(accessPointDetails?.controllerType)) && configuration.formOptions.entry && (
                <TextInput
                    name=""
                    maxLength={14}
                    description={entryDeviceSerialNum?.description}
                    placeholder={`${configuration?.value === 5 ? "Reader" : configuration?.value === 6 ? "Door Lock" : "Entry Reader"} Serial Number`}
                    value={entryDeviceSerialNum?.value}
                    error={entryDeviceSerialNum?.error}
                    onChange={(e) => handleSerialDescription(e.target.value, 'entry')}
                />
            )}
            {(!accessPointDetails?.withController || ['1', '4'].includes(accessPointDetails?.controllerType)) && configuration.formOptions.exit && (
                <TextInput
                    name=""
                    maxLength={14}
                    description={exitDeviceSerialNum?.description}
                    placeholder="Exit Reader Serial Number"
                    value={exitDeviceSerialNum?.value}
                    error={exitDeviceSerialNum?.error}
                    onChange={(e) => handleSerialDescription(e.target.value, 'exit')}
                />
            )}
            {entryDeviceSerialNum?.value?.substring(0, 4) !==
                exitDeviceSerialNum?.value?.substring(0, 4) &&
                configuration?.formOptions?.exit && (
                    <p className={styles.access_alert}>
                        Your entry device and exit device serial numbers are not matching
                    </p>
                )}

            {entryDeviceSerialNum?.value && entryDeviceSerialNum?.value === exitDeviceSerialNum?.value &&
                configuration?.formOptions?.exit && (
                    <p className={styles.access_alert}>
                        Your entry device and exit device cannot be the same
                    </p>
                )}

            {configuration?.value === 9 && <Dropdown
                placeholder="Application"
                value={configuration?.channelExtenderSettings?.application}
                onChange={(data) => {
                    setConfiguration(prev => ({
                        ...prev,
                        channelExtenderSettings: {
                            ...prev?.channelExtenderSettings,
                            application: data
                        }
                    }));
                }}
                data={["Elevator", "Locker"]}
            />}

            {configuration?.value === 9 &&
                <FlexColumn alignItems="start">
                    <Dropdown
                        placeholder="No of boards"
                        value={configuration?.channelExtenderSettings?.numberOfBoards}
                        onChange={(data) => {
                            const totalChannels = data * 16
                            const tempChannelMappings = configuration?.channelExtenderSettings?.channelMapping || {}
                            const channels = Object?.keys(configuration?.channelExtenderSettings?.channelMapping || {});
                            for (let i = 0; i < channels?.length; i++) {
                                const id = parseInt(channels[i].replace("CH", ""), 10);
                                if (id > totalChannels) {
                                    delete tempChannelMappings[channels[i]]
                                }
                            }
                            setConfiguration(prev => ({
                                ...prev,
                                channelExtenderSettings: {
                                    ...prev?.channelExtenderSettings,
                                    numberOfBoards: data,
                                    channelMapping: tempChannelMappings
                                }
                            }));
                        }}
                        data={[1, 2, 3, 4]}
                    />
                    <Typography variant={"b3R"} color={colors.grey500}>The reader and the boards are linked in a series configuration. The board that connects to the reader is the first board in the series, while the board connected to the first board is the second board, and this pattern continues onward.</Typography>

                    <SButton disabled={!configuration?.channelExtenderSettings?.numberOfBoards} variant={"secondary"} color={"info"} onClick={() => { setElevatorMapping(true) }}>Board and {configuration?.channelExtenderSettings?.application} Mapping <ArrowRightIcon style={{ marginLeft: '0.5rem' }} size={16} /></SButton>
                </FlexColumn>}

            {/* DO NOT REMOVE REQUIRED IN NEXT PHASE */}
            {/* {accessPointDetails?.withController && accessPointDetails?.controllerType === "1" && */}
            {false &&
                <>
                    <div className={styles['divider']} />
                    <div className={styles['column']}>
                        <div className={styles['row']}>
                            <div className={styles['column']}>
                                <h2 className={styles['bold-text']}>Aux Input</h2>
                                <p className={styles['note']}>Connect a device on the Weigand port</p>
                            </div>
                            <Switch
                                checked={auxInput?.enabled}
                                onChange={() => { setAuxInput(prev => ({ ...prev, enabled: !prev?.enabled })) }}
                            />
                        </div>
                        {auxInput?.enabled && <RadioGroup aria-label="AUX-Input-Type" name="auxInputType" value={auxInput?.inputType} onChange={(e) => { setAuxInput(prev => ({ ...prev, inputType: e?.target?.value })) }}>
                            <FormControlLabel value="3" control={<StyledRadio />} label="Others" />
                            <FormControlLabel value="1" control={<StyledRadio />} label="Keypad" />
                            <FormControlLabel value="2" control={<StyledRadio />} label="UHF Reader" />
                        </RadioGroup>}
                    </div>
                </>
            }

        </div>

        <FlexRow styles={{ marginTop: '1rem' }} justifyContent="end" className={styles["fixed-actions"]}>
            <SButton disabled={inProgress} color={"grey"} minWidth onClick={() => { hBack && hBack(1) }}>Back</SButton>
            <SButton disabled={inProgress || disabled} minWidth onClick={handleNext}>Next</SButton>
        </FlexRow>
        {showElevatorMapping && <BoardMapping
            application={configuration?.channelExtenderSettings?.application}
            noOfBoards={configuration?.channelExtenderSettings?.numberOfBoards}
            prevChannelMapping={configuration?.channelExtenderSettings?.channelMapping}
            onBack={() => { setElevatorMapping(false) }}
            onSave={(cMapping, cOptions) => {
                setConfiguration(prev => ({
                    ...prev,
                    channelExtenderSettings: {
                        ...prev?.channelExtenderSettings,
                        channelMapping: cMapping,
                        channelOptions: cOptions || []
                    }
                }));
                setElevatorMapping(false)
            }}
            prevFloors={configuration?.channelExtenderSettings?.channelOptions}
        />}
    </>)
};

export default Configuration;